export default "__VITE_ASSET__117ebd0e__"